// extracted by mini-css-extract-plugin
module.exports = {"theme-light":"SwitchTheme_theme-light__cpyxt","theme-dark":"SwitchTheme_theme-dark__2V_nh","switchTheme":"SwitchTheme_switchTheme__ZU4v9"};